/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import Logo from '../../img/logo_login_red.svg';
import { CustomHeaderProps } from '../../interfaces/Signature';
import { CHImg, CustomHeaderStyle } from './HeaderStyledComponents';


const CustomHeader: React.FC<CustomHeaderProps> = ({ firmaStyle, typeSignature }) => {
  return (
    <>
      {(firmaStyle === 'ECO' ||
        firmaStyle === 'CHO' ||
        firmaStyle === 'CEX') && (
          <>
            <CustomHeaderStyle>
              <CHImg>
                <img height="28px" src={Logo} alt="Logo" />
              </CHImg>
            </CustomHeaderStyle>
{/*             <CFCustomSeparator typeSignature= {typeSignature}>
              {<CustomSeparator />}
            </CFCustomSeparator> */}
          </>
        )}
    </>
  );
};

export default CustomHeader;